import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { diffApi } from "../report/services/diff.api";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
/** Initial state for files diff table filter */
export const initFilter = {
    file_name: "",
    ui_file_id: null,
    change_type: "ALL",
    has_behavior_changes: false,
};
/** Initial state for files diff table sort */
export const initSort = {
    property: "changes_count",
    reverse: true,
};
/** Initial state for files diff table pagination */
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
    filteredByLink: false,
};
export const filesDiffSlice = createSlice({
    name: "filesDiff",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.filter.ui_file_id = null;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
            state.filteredByLink = false;
        },
        sourceFiltered: (state, action) => {
            state.filter = cloneDeep(initialState.filter);
            state.filter.ui_file_id = action.payload.id;
            state.filter.file_name = action.payload.name;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        sortUpdated: (state, action) => {
            state.sort = action.payload;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = action.payload.expand;
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "filesDiff");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addMatcher(diffApi.endpoints.getSingleFileDiff.matchFulfilled, (state, action) => {
            if (!state.filteredByLink)
                return;
            state.expandedRows[action.payload.id] = true;
            state.focusedRow = action.payload.id;
        });
    },
});
export const { filterUpdated, sourceFiltered, sortUpdated, paginationUpdated, expandedRowsUpdated, focusedRowUpdated, } = filesDiffSlice.actions;
export const selectFilter = (state) => state.report.filesDiff.filter;
export const selectSort = (state) => state.report.filesDiff.sort;
export const selectPagination = (state) => state.report.filesDiff.pagination;
export const selectExpandedRow = (state, id) => state.report.filesDiff.expandedRows[id] !== undefined;
export const selectExpandedRowPagination = (state, id) => state.report.filesDiff.expandedRows[id];
export const selectFocusedRow = (state) => state.report.filesDiff.focusedRow;
export const selectFilteredByLink = (state) => state.report.filesDiff.filteredByLink;
export const filesDiffReducer = filesDiffSlice.reducer;
export * as default from "./filesDiffSlice";
//# sourceMappingURL=filesDiffSlice.js.map